import Dexie from "dexie";

export default class DBHandler extends Dexie{
    constructor(){
        super("MyTestDatabase");
        this.version(1).stores({
            geomodel: 'id, positions, colors, faces',
        });
    }
    async addnewData(id,data){
        await this.geomodel.add({
            id:id,
            positions:data.positions,
            colors:data.colors,
            faces:data.faces
          });
        //console.log(id);
    }
}
